import { call, put, takeLatest } from 'redux-saga/effects';
import ApiUtil from 'src/utils/ApiUtil';
import {
  CURRENT_COUNTRY_CODE_QUERY_START,
  getCurrentCountryCodeQueryFailedAction,
  getCurrentCountryCodeQuerySuccessAction,
} from 'src/actions/CurrentCountryCodeQueryAction';

export function* getCurrentCountryCode() {
  try {
    // @ts-expect-error
    const response = yield call(
      ApiUtil.callApiWithTimeout,
      'getcurrentcountry',
      {},
    );
    yield put(getCurrentCountryCodeQuerySuccessAction(response));
  } catch {
    yield put(getCurrentCountryCodeQueryFailedAction());
  }
}

export default function* currentCountryCode() {
  yield takeLatest(CURRENT_COUNTRY_CODE_QUERY_START, getCurrentCountryCode);
}
